export enum DeclarationStatus {
  NotCreated = 'NotCreated',
  Created = 'Created',
  Submitted = 'Submitted',
  ComplianceChecked = 'ComplianceChecked'
}
